// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"a8ed0269","470":"1b1d043c","825":"2e9c8ebb"}[chunkId] + ".chunk.js";
};